<template>
  <div>
    <v-data-table
      :items="data"
      :headers="headers"
      :loading="isLoading"
      class="body-2"
      :show-select="isMultiSelect"
      :single-select="isMultiSelect"
      :options.sync="pagination"
      v-model="selectedCustomers"
      item-key="id"
      :footer-props="footerProps"
      :items-per-page="paginationMeta.itemsPerPage"
      :no-data-text="$dictionary.app.common.customers.noData"
      :server-items-length="paginationMeta.serverItemsLength"
      :loading-text="$dictionary.app.common.customers.loading"
    >
      <template v-if="isMultiSelect" #item.email="{ item }">
        <table-matrics-row
          is-link
          is-text-pointer
          :text="item.email"
          text-class="blue--text"
          :query="{ active_tab: 'profile' }"
          :navigate-to="`${$paths.users}/${item.id}/user`"
        />
      </template>
      <template #item.created_at="{ item }">
        <table-matrics-row :text="formatDateToAmPm(item.created_at)" />
      </template>

      <template #item.updated_at="{ item }">
        <table-matrics-row :text="formatDateToAmPm(item.updated_at)" />
      </template>
      <template #item.role>
        <table-matrics-row :text="capitalize('Owner')" />
      </template>
      <template #header.data-table-select="{ props, on }">
        <v-simple-checkbox
          v-ripple
          v-on="on"
          v-bind="props"
          :class="{
            'selected-records-checkbox': props && props.indeterminate,
          }"
          color="primary"
          :value="props && props.value"
          indeterminate-icon="mdi-minus-box"
          :indeterminate="props && props.indeterminate"
        />
      </template>

      <template #item.data-table-select="{ isSelected, select }">
        <v-simple-checkbox
          color="primary"
          v-ripple
          :value="isSelected"
          @input="select(!isSelected)"
        />
      </template>

      <template #item.name="{ item }">
        <table-matrics-row v-if="isMultiSelect" :text="getName(item)" />
        <slot v-else name="record" :item="item" />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { PaginationSortMixin } from "@/mixins";
import { TableMatricsRow } from "@/components/shared";
import { capitalize, formatDateToAmPm } from "@/filters";

import { getName } from "@/utils/common.utils";

/**
 * User customers table listing
 */
export default {
  name: "UserCustomersTable",
  /**
   * ---------------- Mixins ------------------
   */
  mixins: [PaginationSortMixin],
  /**
   * ---------------- Custom events ------------------
   */
  emits: ["update-customers"],
  /**
   * ---------------- Props ------------------
   */
  props: {
    data: { type: Array, default: () => [], required: true },
    isLoading: { type: Boolean, default: false, required: true },
    defaultSortOrder: { type: String, default: "" },
    updateRecord: { type: Boolean, default: false },
    resetSelectedCustomers: { type: Boolean, default: false },
    headers: { type: Array, default: () => [], required: true },
    isMultiSelect: { type: Boolean, default: false },
  },
  /**
   * ---------------- Components ------------------
   */
  components: {
    TableMatricsRow,
  },
  /**
   * ---------------- Data properties ------------------
   */
  data() {
    return {
      selectedCustomers: [],
    };
  },
  /**
   * ---------------- Methods ------------------
   */
  methods: {
    getName,
    capitalize,
    formatDateToAmPm,
  },
  /**
   * ---------------- Watching properties ------------------
   */
  watch: {
    /**
     * @emits update-customers event in the parent component
     */
    selectedCustomers(val) {
      this.$emit("update-customers", val);
    },
    /**
     * @emits get-records event in the parent component to fetch updated records
     */
    updateRecord() {
      this.getRecords();
    },
    /**
     * Reset selected customers to empty array
     */
    resetSelectedCustomers() {
      this.selectedCustomers = [];
    },
  },
  /**
  |--------------------------------------------------
  | Created lifecycle hook
  |--------------------------------------------------
  */
  created() {
    this.getRecords();
  },
};
</script>
